import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, ActionSheetController, AlertController, ToastController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { ModalPessoaPage } from '../../modal-pessoa/modal-pessoa.page';
import { Browser } from '@capacitor/browser';
import { GrupoGerenciarReunioesPage } from '../grupo-gerenciar-reunioes/grupo-gerenciar-reunioes.page';
import { EditorHtmlPage } from '../../editor-html/editor-html.page';
import { GrupoParticipantesPresencaPage } from '../grupo-participantes-presenca/grupo-participantes-presenca.page';
import { GrupoAddReuniaoPage } from '../grupo-add-reuniao/grupo-add-reuniao.page';
import { GrupoVisitantesPresencaPage } from '../grupo-visitantes-presenca/grupo-visitantes-presenca.page';
import { GrupoGerenciarEsporadicoPage } from '../grupo-gerenciar-esporadico/grupo-gerenciar-esporadico.page';
import { GrupoResumoPage } from '../grupo-resumo/grupo-resumo.page';
import { GrupoFeedbackPage } from '../grupo-feedback/grupo-feedback.page';
import { GrupoMensagemAddPage } from '../grupo-mensagem-add/grupo-mensagem-add.page';
import { GrupoMensagemPage } from '../grupo-mensagem/grupo-mensagem.page';
import { GrupoPautaPage } from '../grupo-pauta/grupo-pauta.page';
import { GrupoCheckListPage } from '../grupo-check-list/grupo-check-list.page';
import { GrupoAdmGraficoPage } from '../grupo-adm-grafico/grupo-adm-grafico.page';
import { GrupoAdmImagemPage } from '../grupo-adm-imagem/grupo-adm-imagem.page';
import { GrupoGerenciarParticipantesPage } from '../grupo-gerenciar-participantes/grupo-gerenciar-participantes.page';
import { GrupoGerenciarVisitantesPage } from '../grupo-gerenciar-visitantes/grupo-gerenciar-visitantes.page';
import { GrupoCaixaPage } from '../grupo-caixa/grupo-caixa.page';
import { GrupoAdmDadosPage } from '../grupo-adm-dados/grupo-adm-dados.page';
import { GrupoAdmEnderecoPage } from '../grupo-adm-endereco/grupo-adm-endereco.page';
import { GrupoAdmHierarquiaPage } from '../grupo-adm-hierarquia/grupo-adm-hierarquia.page';
import { GrupoAdmHorarioPage } from '../grupo-adm-horario/grupo-adm-horario.page';
import { addDays, format, isBefore, isEqual, subDays } from 'date-fns';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ImagePipe } from 'src/app/pipes/image/image';
import { EnderecoPipe } from 'src/app/pipes/endereco/endereco';
import { PhonePipe } from 'src/app/pipes/phone/phone';
import { NomenclaturaService } from 'src/app/services/nomenclatura/nomenclatura';
import { GrupoGerenciarSolicitacoesAdmPage } from '../grupo-gerenciar-solicitacoes-adm/grupo-gerenciar-solicitacoes-adm.page';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { CapacitorCalendar } from '@ebarooni/capacitor-calendar';
import { MdaPessoaPage } from '../../mda/mda-pessoa/mda-pessoa.page';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
import { environment } from 'src/environments/environment';
import { MensagemProvider } from 'src/app/services/mensagem/mensagem';
import { ProverDatepickerComponent } from 'src/app/components/prover-datepicker/prover-datepicker';

declare var instituicaoConstants: { IS_CONVENCAO: any; IS_PWA: any; };

@Component({
  selector: 'app-grupo-detalhes',
  templateUrl: './grupo-detalhes.page.html',
  styleUrls: ['./grupo-detalhes.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgCircleProgressModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    NomenclaturaPipe,
    EnderecoPipe,
    PhonePipe,
    SemRegistroComponent,
    LoadingSpinnerComponent,
    ProverDatepickerComponent
  ],
})
export class GrupoDetalhesPage implements OnInit {
  idGrupo: string = "";
  endereco: any = {};
  hierarquiaList: any = [];
  grupo: any = {};
  admin: boolean = false;
  nomenclaturaDesc: string = "";
  showAddMensagem: boolean = false;
  grupoTab: string = 'inicio';
  loader = this.loadingController.create({
    message: this.translate.instant("Carregando")
  });
  loaded: boolean = false;
  public isConvencao: boolean = instituicaoConstants.IS_CONVENCAO;
  public isPWA: boolean = instituicaoConstants.IS_PWA;
  tipo;
  resumoData: any;
  visualizar: any;
  gerenciar: boolean;
  isMessianica = false;
  dataInicio = format(subDays(new Date(), 10), "yyyy-MM-dd");
  dataFim = format(new Date(), "yyyy-MM-dd");
  pagination: any = { currentPage: 0, pageCount: 0 };
  filtroAtual: any = {};
  reunioesPassadas: any = [];
  ordemAscendente = true;
  grupoTabReuniao = 'reunioesAtuais';
  showReuniao = false;
  openModal = false;
  loading = false;
  private passadasReqId = 0;
  isMensagemParticipante = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public userProvider: UserProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private nomenclatura: NomenclaturaService,
    private translate: TranslateService,
    public enderecoPipe: EnderecoPipe,
    public msgProvider: MensagemProvider,
  ) {
    this.isMessianica = environment.isMessianica;
    this.admin = this.navParams.get('admin');
    this.tipo = this.navParams.get('tipo');
    this.idGrupo = this.navParams.get('id');
    this.nomenclatura.transform(this.getNomenclatura(this.tipo)).then(data => this.nomenclaturaDesc = data);
    if (this.navParams.get('aba')) {
      this.grupoTab = this.navParams.get('aba');
    }

    if (this.tipo == '1') {
      this.visualizar = this.userProvider.hasConfig('113');
    } else if (this.tipo == '2') {
      this.visualizar = this.userProvider.hasConfig('177');
    }

    const tipoConfigMap: any = {
      '1': '235',
      '2': '237',
      '3': '236'
    };

    const configCode = tipoConfigMap[this.tipo];
    this.gerenciar = configCode ? this.userProvider.hasConfig(configCode) : false;

    this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: { proximaReuniao: { data: number; }; }) => {
      this.grupo = data;
      const usuarioEhParticipante = this.grupo.participantes?.some(
        (p: any) => p.id === this.userProvider.loggedUser.id
      ) ?? false;

      this.isMensagemParticipante = usuarioEhParticipante;

      var d = format(new Date(), "yyyy-MM-dd");
      if (this.userProvider.hasConfig('181')) {
        if (this.grupo.proximaReuniao != null) {
          // if (data.proximaReuniao.data > d) {
          this.resumoData = true;
          // }
        } else {
          this.resumoData = true;
        }
      } else {
        this.resumoData = true;
      }

      this.grupoProvider.frequenciaParticipante(this.idGrupo).subscribe((data2: { frequencia: { [x: string]: any; }; }) => {
        for (let i = 0; i < this.grupo.participantes.length; i++) {
          if (data2.frequencia[this.grupo.participantes[i].id])
            this.grupo.participantes[i].frequencia = data2.frequencia[this.grupo.participantes[i].id];
          else
            this.grupo.participantes[i].frequencia = false;
        }
      });

      this.carregarPassadas(null);

      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    });

    this.grupoProvider.buscarGrupoEndereco(this.idGrupo).subscribe((data: any) => {
      this.endereco = data;
    });

    this.grupoProvider.getHierarquia(this.idGrupo, this.tipo).subscribe((data: any) => {
      this.hierarquiaList = data;
    });
  }

  ngOnInit() { }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async editarReuniao(idReuniao: any) {
    var data = { idGrupo: this.idGrupo, idReuniao: idReuniao };
    const modalPage = await this.modalCtrl.create({ component: GrupoAddReuniaoPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    if (data) {
      this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: any) => {
        this.grupo = data;
      });
    }

  }

  async novaMensagem() {
    var data = {
      idGrupo: this.idGrupo,
      isAdm: this.grupo.permissaoEditar,
      isParticipante: this.isMensagemParticipante
    };
    const modalPage = await this.modalCtrl.create({ component: GrupoMensagemAddPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    if (data) {
      this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: any) => {
        this.grupo = data;
      });
    }

  }

  async openMensagem(mensagem: { id: any; dataLido: { idMensagem: any; idGrupo: string; }; }) {
    var data = { idMensagem: mensagem.id, idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoMensagemPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    if (data) {
      mensagem.dataLido = data;
    }

  }

  onSegmentChanged(segmentButton: any) {
    this.showAddMensagem = segmentButton.detail.value == 'mensagem' ? true : false;
    this.showReuniao = segmentButton.detail.value == 'reuniao' ? true : false;
  }

  async opcoesParticipantes(pessoa: { id: any; }, isVisitante = false) {
    if (this.grupo.permissaoEditar || this.admin) {
      let actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('Opções'),
        buttons: [
          {
            text: this.translate.instant('Dados de Contato'),
            handler: async () => {
              await actionSheet.dismiss();

              if (pessoa.id) {
                var data = {
                  idPessoa: pessoa.id,
                  modoReduzido: 'true',
                  permissao: this.grupo.permissaoEditar,
                  origem: true,
                  isVisitante: isVisitante
                };

                const modalPage = await this.modalCtrl.create({ component: ModalPessoaPage, componentProps: data });
                modalPage.present();
              } else {
                this.alertPessoaInstituicao();
              }
            }
          }

        ]
      });

      const btnMda = {
        text: this.translate.instant('Discipulado'),
        handler: async () => {
          await actionSheet.dismiss();

          const data = { pessoa: pessoa, meuCadastro: false };
          const modalPage = await this.modalCtrl.create({ component: MdaPessoaPage, componentProps: data });
          modalPage.present();
        }
      };

      if (this.userProvider.hasConfig(19) && this.userProvider.hasConfig(46) && !this.isConvencao) {
        actionSheet.buttons = actionSheet.buttons.concat(btnMda);
      }

      if ((this.isMessianica && this.userProvider.hasConfig(242)) || !this.isMessianica) {
        actionSheet.buttons = actionSheet.buttons.concat({
          text: this.translate.instant('Utilizar Endereço para ') + this.nomenclaturaDesc,
          handler: async () => {
            await actionSheet.dismiss();

            let confirmAlert = await this.alertCtrl.create({
              cssClass: "alerta-personalizado",
              mode: "ios",
              header: this.translate.instant('Atenção'),
              message: this.translate.instant('Deseja realmente fazer o endereço dessa pessoa como endereço do(a) ') + this.nomenclaturaDesc + '?',
              buttons: [
                {
                  text: this.translate.instant('Não'),
                  role: 'cancel',
                },
                {
                  text: this.translate.instant('Sim'),
                  handler: () => {
                    this.grupoProvider.alterarEnderecoGrupoPessoa(this.idGrupo, pessoa.id).subscribe((data: any) => {
                      this.endereco = data;
                    });
                  },
                },
              ],
            });

            confirmAlert.present();
          }
        });
      }

      actionSheet.present();
    } else if (
      this.userProvider.hasConfig(103) ||
      this.userProvider.hasConfig(104) ||
      this.userProvider.hasConfig(105)
    ) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('Opções'),
        buttons: [
          {
            text: this.translate.instant('Dados de Contato'),
            handler: async () => {
              await actionSheet.dismiss();

              if (pessoa.id) {
                var data = { idPessoa: pessoa.id, modoReduzido: 'true', membro: true, isVisitante: isVisitante };
                const modalPage = await this.modalCtrl.create({ component: ModalPessoaPage, componentProps: data });
                modalPage.present();
              } else {
                this.alertPessoaInstituicao();
              }
            }
          },
          {
            text: 'Cancelar',
            handler: async () => {
              await actionSheet.dismiss();
            }
          }
        ]
      });

      actionSheet.present();
    }
  }

  confirmar(presenca: any, idGrupo: any, idProjeto: any) {
    this.grupoProvider.confirmarPresenca(presenca, idGrupo, idProjeto)
      .subscribe((data: { numPresentes: any; pesenca: any; }) => {
        this.grupo.proximaReuniao.numPresentes = data.numPresentes;
        this.grupo.presencaConfirmada = data.pesenca;
      });
  }

  async abrirPauta(reuniao: { pauta: any; id: any; }) {
    this.grupoProvider.getPauta(reuniao.id).subscribe(async (data: any) => {
      reuniao.pauta = data;

      const pautaModal = { pauta: reuniao.pauta, idReuniao: reuniao.id };
      const modalPage = await this.modalCtrl.create({ component: GrupoPautaPage, componentProps: pautaModal });
      modalPage.present();
    });
  }

  async presencaParticipantes(idReuniao: any) {
    var data = { idReuniao: idReuniao };
    const modalPage = await this.modalCtrl.create({ component: GrupoParticipantesPresencaPage, componentProps: data });
    modalPage.present();

    const returnModal = (await modalPage.onDidDismiss());
    if (!returnModal.data) return;

    if (!this.userProvider.hasConfig(167)) {
      this.presencaVisitantes(idReuniao);
    } else if (!this.userProvider.hasConfig(169)) {
      this.visitanteEsporadico(idReuniao);
    } else if (!this.userProvider.hasConfig(174) && this.resumoData) {
      this.resumo(idReuniao);
    }
  }

  async presencaVisitantes(idReuniao: any) {
    var data = { idReuniao: idReuniao };
    const modalPage = await this.modalCtrl.create({ component: GrupoVisitantesPresencaPage, componentProps: data });
    modalPage.present();
    const returnModal = (await modalPage.onDidDismiss());
    if (!returnModal.data) return;

    if (!this.userProvider.hasConfig(169)) {
      this.visitanteEsporadico(idReuniao);
    } else if (!this.userProvider.hasConfig(174) && this.resumoData) {
      this.resumo(idReuniao);
    }
  }

  async visitanteEsporadico(idReuniao: any) {
    var data = { idReuniao: idReuniao, idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoGerenciarEsporadicoPage, componentProps: data });
    modalPage.present();

    const returnModal = (await modalPage.onDidDismiss());
    if (!returnModal.data) return;

    if (!this.userProvider.hasConfig(174) && this.resumoData) {
      this.resumo(idReuniao);
    }
  }

  async check(idReuniao: any) {
    var data = { idReuniao: idReuniao };
    const modalPage = await this.modalCtrl.create({ component: GrupoCheckListPage, componentProps: data });
    modalPage.present();
  }

  async resumo(idReuniao: any) {
    var data = { idReuniao: idReuniao };
    const modalPage = await this.modalCtrl.create({ component: GrupoResumoPage, componentProps: data });
    modalPage.present();

    const returnModal = (await modalPage.onDidDismiss());
    if (returnModal.data != 0) {
      this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: any) => {
        this.grupo = data;
      });
    }
  }

  async addReuniao() {
    var data = { idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoAddReuniaoPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    if (data) {
      this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: any) => {
        this.grupo = data;
      });
    }

  }

  async gerenciarReunioes() {
    const tipoGrupo = this.getNomenclatura(this.tipo);
    var data = { idGrupo: this.idGrupo, tipo: tipoGrupo };

    const modalPage = await this.modalCtrl.create({ component: GrupoGerenciarReunioesPage, componentProps: data });

    modalPage.present();

    (await modalPage.onDidDismiss()).data
    this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: any) => {
      this.grupo = data;
    });

  }

  async gerenciarGraficos() {
    var data = { idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoAdmGraficoPage, componentProps: data });
    modalPage.present();
  }

  async gerenciarParticipantes() {
    var data = { idGrupo: this.idGrupo, participantes: this.grupo.participantes, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({ component: GrupoGerenciarParticipantesPage, componentProps: data });
    modalPage.present();

    const pessoa = (await modalPage.onDidDismiss())
    if (pessoa.data) {
      this.grupo.participantes = pessoa.data;
    } else {
      this.grupo.participantes = this.grupo.participantes;
    }
  }

  async gerenciarVisitantes() {
    var data = { idGrupo: this.idGrupo, visitantes: this.grupo.visitantes };
    const modalPage = await this.modalCtrl.create({ component: GrupoGerenciarVisitantesPage, componentProps: data });
    modalPage.present();

    const visitante = (await modalPage.onDidDismiss())
    if (visitante.data) {
      if (visitante.data === 'migracao') {
        let loader = this.loadingController.create({
          message: this.translate.instant("Carregando")
        });
        // loader.present();
        this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: any) => {
          this.grupo = data;
          // loader.dismiss();
        });
      } else {
        this.grupo.visitantes = visitante.data;
      }
    }
  }

  editarPauta(idReuniao: any) {
    this.grupoProvider.getPauta(idReuniao).subscribe(async (data: boolean) => {
      const pautaText = { html: data, titulo: this.translate.instant('Pauta') };
      const modalPage = await this.modalCtrl.create({ component: EditorHtmlPage, componentProps: pautaText });
      modalPage.present();

      const pauta = (await modalPage.onDidDismiss())
      if (pauta.data) {
        this.grupoProvider.savePauta(idReuniao, pauta.data).subscribe(async () => {
          const toast = await this.toastCtrl.create({
            message: this.translate.instant('Pauta salva com sucesso!'),
            duration: 3000
          });

          toast.present();
        });
      }
    });
  }

  async gerenciarCaixa() {
    var data = { idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoCaixaPage, componentProps: data });
    modalPage.present();
  }

  async addFoto(id: any) {
    var data = { idGrupo: id };
    const modalPage = await this.modalCtrl.create({ component: GrupoAdmImagemPage, componentProps: data });
    modalPage.present();
  }

  async editarDados(id: any) {
    var data = { id: id, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({ component: GrupoAdmDadosPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    if (data) {
      this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: any) => {
        this.grupo = data;
      });
    }
  }

  async gerenciarSolicitacao() {
    const data = { idGrupo: this.idGrupo, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({ component: GrupoGerenciarSolicitacoesAdmPage, componentProps: data });
    modalPage.present();
  }

  async editarEndereco(id: any) {
    var data = { endereco: this.endereco, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({ component: GrupoAdmEnderecoPage, componentProps: data });
    modalPage.present();


    (await modalPage.onDidDismiss()).data
    if (data) {
      this.grupoProvider.buscarGrupoEndereco(this.idGrupo).subscribe((data: any) => {
        this.endereco = data;
      });
    }
  }

  async editarHorarios(id: any) {
    var data = { id: id, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({ component: GrupoAdmHorarioPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    this.grupoProvider.getGrupoDetalhes(this.idGrupo).subscribe((data: any) => {
      this.grupo = data;
    });
  }

  async editarHierarquia(id: any) {
    var data = { idGrupo: id, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({ component: GrupoAdmHierarquiaPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    this.grupoProvider.getHierarquia(this.idGrupo, this.tipo).subscribe((data: any) => {
      this.hierarquiaList = data;
    });
  }

  public async openLink(link: { target: string; url: string; }) {
    await Browser.open({ url: link.url });
  }

  async feedback() {
    var data = { idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoFeedbackPage, componentProps: data });
    modalPage.present();
  }

  async calendario(reuniao: { dataInicio: string | number | Date; dataFim: string | number | Date; tema?: string; tipoProjeto?: string; }) {
    const inicio = new Date(reuniao.dataInicio);
    const fim = new Date(reuniao.dataFim);
    try {
      await CapacitorCalendar.requestFullCalendarAccess();

      await CapacitorCalendar.createEventWithPrompt({
        title: reuniao.tema || '',
        location: '',
        description: reuniao.tipoProjeto || '',
        startDate: inicio.getTime(),
        endDate: fim.getTime(),
      });
    } catch (err) {
      console.error('Erro ao criar evento:', err);
    }
  }

  abrirMapa(endereco: any) {
    const url = 'http://maps.google.com/?q=' + this.enderecoPipe.transform(endereco, true);
    window.open(url, '_blank');
  }

  getNomenclatura(tipo: string) {
    const tipoMap: Record<string, string> = {
      '2': 'ministerio',
      '3': 'ebd',
    };

    return tipoMap[tipo] || 'grupo';
  }

  async alertPessoaInstituicao() {
    let confirmAlert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Atenção'),
      message: this.translate.instant('Você não tem permissão para acessar este cadastro. Entre em contato com a instituição.'),
      buttons: [
        {
          text: this.translate.instant('Ok'),
          role: 'cancel',
        },
      ],
    });

    confirmAlert.present()
  }

  async deleteOne(id: any) {
    (
      await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Confirmar exclusão'),
        buttons: [
          {
            text: this.translate.instant('Cancelar'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('Excluir'),
            cssClass: 'danger',
            handler: () => {
              this.msgProvider.excluir([id]).subscribe((res: any) => {
                this.excluirMensagemLista(id);
              });
            },
          },
        ],
      })
    ).present();
  }

  excluirMensagemLista(id: any): any {
    for (var i = 0; i < this.grupo.mensagens.length; i++) {
      if (this.grupo.mensagens[i].id == id) {
        this.grupo.mensagens.splice(i, 1);
        return true;
      }
    }
  }

  orderDescAsc() {
    this.ordemAscendente = !this.ordemAscendente;
    this.carregarPassadas(null);
  }

  async filtrar() {
    const result =
      isBefore(new Date(this.dataInicio), new Date(this.dataFim)) ||
      isEqual(new Date(this.dataInicio), new Date(this.dataFim));

    if (!result) {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("Informe uma data válida"),
        duration: 3000,
      });
      toast.present();
    } else {
      this.carregarPassadas(null);
      this.open();
    }
  }

  async carregarPassadas(infiniteScroll: { target: { complete: () => void } } | null) {
    const reqId = ++this.passadasReqId;

    if (!infiniteScroll) {
      this.pagination = { currentPage: 0, pageCount: 10 };
      this.reunioesPassadas = [];
    }

    const user = await this.userProvider.getDados();

    this.filtroAtual = {
      dataInicio: this.dataInicio,
      dataFim: this.dataFim,
      ordem: this.ordemAscendente,
      idParticipante: this.userProvider.hasConfig(245) ? null : user.id,
      isHistorico: true
    };

    this.grupoProvider.postReunioes(this.idGrupo, this.filtroAtual, this.pagination)
      .subscribe((res) => {
        if (reqId !== this.passadasReqId) {
          infiniteScroll?.target.complete();
          return;
        }

        this.reunioesPassadas = this.reunioesPassadas.concat(res.dados);
        this.pagination = res.pagination;
        infiniteScroll?.target.complete();
      });
  }

  open() {
    this.openModal = false;
  }
}
